import React from 'react';
import { Box } from '../box';

interface IProps {
  children: React.ReactNode;
}

export const Page = ({ children }: IProps) => {
  return (
    <Box height={'100%'}>
      <Box
        height={'100%'}
        position={'relative'}
        margin={'0 auto'}
        maxWidth={['100%', '100%', '1440px']}
      >
        {children}
      </Box>
    </Box>
  );
};
